import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';

export default class TpClientInvoiceViewDescription {
  static invoiceService = TpClientInvoiceService.GetInvoicePdfById;
  static title = 'Client Invoice Preview';
  static fileNamePrefix = 'client_invoice';
  static attachInvoiceServiceFunction = TpClientInvoiceService.AttachReportAsync;
}
